<template>
	<v-dialog v-model="dialog" persistent max-width="600" scrollable>
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-14 font-weight-bold cl-secondary">Info Produk</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text v-if="product">
				<div class="py-5">
					<v-row class="">
						<v-col sm="12" md="6" xl="4">
							<v-card outlined class="pa-4">
								<v-img
									width="100%"
									:src="(product.product_image) ? product.product_image : '/assets/image/no-image-post.png'"
								></v-img>
							</v-card>
						</v-col>
						<v-col sm="12" md="6" xl="8">
							<div class="d-flex flex-column">
								<h2 class="primary--text text-capitalize mb-5">{{ product.product_name }}</h2>
								<span class="d-flex flex-column align-start mb-2 font-size-12">
									<span>Stok</span>
									<span class="font-weight-bold" :class="(product.product_qty > 0) ? 'cl-secondary' : 'red--text'">{{ (product.product_qty > 0) ? product.product_qty : 'HABIS' }}</span>
								</span>
								<span class="d-flex flex-column align-start mb-2 font-size-12">
									<span>Harga</span>
									<span class="font-weight-500 cl-secondary text-decoration-line-through">
										{{ product.product_price | toRupiah }}
									</span>
								</span>
								<span class="d-flex flex-column align-start mb-2 font-size-12"><span>Harga Mitra</span><span class="font-size-14 mt-1 font-weight-bold cl-primary">{{ product.product_member_price | toRupiah }}</span></span>
							</div>
						</v-col>
					</v-row>

					<v-row>
						<v-col sm="12" md="12" xl="12">
							<div class="d-block mb-4 font-size-14 font-weight-bold cl-secondary">Keterangan</div>
							<div class="font-size-12 black--text lighten-2" v-html="product.product_description"></div>
						</v-col>
					</v-row>
				</div>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="3">
					<v-btn depressed block color="primary" class="white--text rounded-lg text-capitalize" @click="modalHide">
						<v-icon small v-if="false">mdi-close</v-icon>
						<span>Tutup</span>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
	props: ['product'],
	data () {
		return {
			dialog: false,
		}
	},
	computed: {
		...mapState('article', ['detailArticle']),
	},
	methods: {
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
	}
};
</script>